var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.054 7C10.959 7 10.054 6.095 10.054 5C10.054 4.646 10.157 4.317 10.322 4.027C10.232 4.02 10.146 4 10.054 4C9.25998 4.00524 8.49996 4.32299 7.93849 4.88447C7.37701 5.44595 7.05926 6.20597 7.05402 7C7.05402 8.642 8.41202 10 10.054 10C11.695 10 13.054 8.642 13.054 7C13.054 6.908 13.034 6.822 13.027 6.732C12.737 6.897 12.408 7 12.054 7Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.054 0C2.421 0 0.127 6.617 0.106 6.684L0 7L0.105 7.316C0.127 7.383 2.421 14 10.054 14C17.687 14 19.981 7.383 20.002 7.316L20.108 7L20.003 6.684C19.981 6.617 17.687 0 10.054 0ZM10.054 12C4.703 12 2.63 8.154 2.128 7C2.632 5.842 4.706 2 10.054 2C15.405 2 17.478 5.846 17.98 7C17.476 8.158 15.402 12 10.054 12Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeoutline);
export default __webpack_public_path__ + "static/media/eye.outline.e2cfd2680f580c6badf949afe086a2cc.svg";
export { ForwardRef as ReactComponent };